import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Trophy, BookOpen, Gift } from 'lucide-react';
import { Button } from './Button';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-4 sm:px-6 lg:px-8 relative" data-id="element-226">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-[500px] bg-amber-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-227" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-228">
        <div className="text-center mb-16" data-id="element-229">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-4" data-id="element-230">
            ELEGÍ TU PACKVIAJERO
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-231">
          {/* Completo Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="glass-panel rounded-3xl p-8 border-slate-700 flex flex-col relative mt-4 lg:mt-8" data-id="element-232">
            <div className="mb-8" data-id="element-233">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/20 text-blue-400 font-bold text-sm mb-4" data-id="element-234">
                <BookOpen className="w-4 h-4" data-id="element-235" /> Básico
              </div>
              <h3 className="text-3xl font-bold text-white mb-2" data-id="element-236">
                PACKVIAJERO COMPLETO
              </h3>
              <p className="text-slate-400 font-medium" data-id="element-237">4 Tomos + 4 Bonos</p>
            </div>

            <div className="mb-8" data-id="element-238">
              <p className="text-sm text-slate-400 mb-2 font-medium" data-id="element-239">
                Ideal para:
              </p>
              <p className="text-slate-300" data-id="element-240">
                El viajero que quiere estar preparado para todo
              </p>
            </div>

            <div className="mb-8" data-id="element-241">
              <div className="flex items-center gap-3 mb-1" data-id="element-242">
                <span className="text-2xl text-slate-500 line-through font-bold" data-id="element-243">
                  $45.000
                </span>
                <span className="bg-green-500/20 text-green-400 px-2 py-1 rounded text-xs font-bold" data-id="element-244">
                  -55%
                </span>
              </div>
              <div className="text-5xl font-black text-white" data-id="element-245">
                $19.990{' '}
                <span className="text-xl text-slate-400 font-medium" data-id="element-246">ARS</span>
              </div>
            </div>

            <div className="space-y-4 mb-10 flex-grow" data-id="element-247">
              <div className="flex items-center gap-3" data-id="element-248">
                <Check className="w-5 h-5 text-blue-400 shrink-0" data-id="element-249" />
                <span className="text-slate-300" data-id="element-250">
                  Tomo 1: Fonética y Gramática
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-251">
                <Check className="w-5 h-5 text-blue-400 shrink-0" data-id="element-252" />
                <span className="text-slate-300" data-id="element-253">Tomo 2: El Día a Día</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-254">
                <Check className="w-5 h-5 text-blue-400 shrink-0" data-id="element-255" />
                <span className="text-slate-300" data-id="element-256">Tomo 3: Emergencias</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-257">
                <Check className="w-5 h-5 text-blue-400 shrink-0" data-id="element-258" />
                <span className="text-slate-300" data-id="element-259">Tomo 4: Anti-Estafas</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-260">
                <Gift className="w-5 h-5 text-purple-400 shrink-0" data-id="element-261" />
                <span className="text-slate-300" data-id="element-262">Los 4 Bonos Estratégicos</span>
              </div>
            </div>

            <Button href="https://www.supportrainingpro.com/cart/45067313250440:1" variant="secondary" className="w-full py-5 text-lg" data-id="element-263">
              → QUIERO MI PACKVIAJERO AHORA
            </Button>
          </motion.div>

          {/* Expert Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-gradient-to-b from-slate-800 to-slate-900 rounded-3xl p-8 border-2 border-amber-500 shadow-2xl shadow-amber-500/20 flex flex-col relative" data-id="element-264">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-amber-500 text-slate-900 font-black px-4 py-1 rounded-full text-sm uppercase tracking-wider shadow-lg" data-id="element-265">
              Más elegido
            </div>

            <div className="mb-8 mt-2" data-id="element-266">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/20 text-amber-400 font-bold text-sm mb-4" data-id="element-267">
                <Trophy className="w-4 h-4" data-id="element-268" /> Premium
              </div>
              <h3 className="text-3xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-269">
                PACKVIAJERO EXPERT{' '}
                <Star className="w-6 h-6 fill-amber-400 text-amber-400" data-id="element-270" />
              </h3>
              <p className="text-amber-400 font-medium" data-id="element-271">
                4 Tomos + 4 Bonos + Londres Level Expert
              </p>
            </div>

            <div className="mb-8" data-id="element-272">
              <p className="text-sm text-slate-400 mb-2 font-medium" data-id="element-273">
                Ideal para:
              </p>
              <p className="text-slate-200 font-medium" data-id="element-274">
                El viajero que quiere ahorrar cientos de libras y vivir Londres
                como un local
              </p>
            </div>

            <div className="mb-8" data-id="element-275">
              <div className="flex items-center gap-3 mb-1" data-id="element-276">
                <span className="text-2xl text-slate-500 line-through font-bold" data-id="element-277">
                  $60.000
                </span>
                <span className="bg-green-500/20 text-green-400 px-2 py-1 rounded text-xs font-bold" data-id="element-278">
                  -53%
                </span>
              </div>
              <div className="text-5xl font-black text-white" data-id="element-279">
                $27.990{' '}
                <span className="text-xl text-slate-400 font-medium" data-id="element-280">ARS</span>
              </div>
            </div>

            <div className="space-y-4 mb-10 flex-grow" data-id="element-281">
              <div className="flex items-center gap-3" data-id="element-282">
                <Check className="w-5 h-5 text-amber-400 shrink-0" data-id="element-283" />
                <span className="text-white font-medium" data-id="element-284">
                  Todo lo del Pack Completo
                </span>
              </div>
              <div className="flex items-center gap-3 bg-amber-500/10 p-2 rounded-lg border border-amber-500/20" data-id="element-285">
                <Star className="w-5 h-5 text-amber-400 shrink-0" data-id="element-286" />
                <span className="text-amber-400 font-bold" data-id="element-287">
                  Guía Londres Level Expert
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-288">
                <Check className="w-5 h-5 text-slate-400 shrink-0" data-id="element-289" />
                <span className="text-slate-300" data-id="element-290">
                  Itinerario 5 días bajo costo
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-291">
                <Check className="w-5 h-5 text-slate-400 shrink-0" data-id="element-292" />
                <span className="text-slate-300" data-id="element-293">
                  Trucos de ahorro en transporte
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-294">
                <Check className="w-5 h-5 text-slate-400 shrink-0" data-id="element-295" />
                <span className="text-slate-300" data-id="element-296">
                  Lugares secretos y vistas gratis
                </span>
              </div>
            </div>

            <Button href="https://www.supportrainingpro.com/cart/45067314135176:1" variant="primary" className="w-full py-5 text-lg shadow-amber-500/30" data-id="element-297">
              → QUIERO EL PACKVIAJERO EXPERT
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}